import { render, staticRenderFns } from "./NeuroscienceEvaluation.vue?vue&type=template&id=76f63fe3&"
import script from "./NeuroscienceEvaluation.vue?vue&type=script&lang=ts&"
export * from "./NeuroscienceEvaluation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports